import { numberToReadableFormat } from "@Common/helpers/number";

type CustomYTickProps = {
	viewBox?: { x: number; y: number };
	scaleX?: number;
	scaleY?: number;
	text?: string;
	unitType: string;
};

export default function CustomYTick({ viewBox, scaleX = 1, scaleY = 1.6, text = "", unitType }: Readonly<CustomYTickProps>) {
	const { x, y } = viewBox ?? { x: 0, y: 0 };

	if (y >= 340) {
		return null;
	}

	if (unitType !== "unit") {
		const num = parseFloat(text);
		text = isNaN(num) ? "0.00" : num.toFixed(2);
	}

	const estimatedTextWidth = text.length * 8; // estimate width per character, adjust as needed
	const boxWidth = Math.max(30, estimatedTextWidth); // at least 40 wide
	const xOffset = -boxWidth - 6; // adjust this as needed
	const yOffset = -16; // adjust this as needed

	const pathD = `
			M ${x + xOffset} ${y + yOffset}
			L ${x + xOffset} ${y + yOffset + 20 * scaleY}
			L ${x + xOffset + boxWidth * scaleX} ${y + yOffset + 20 * scaleY}
			L ${x + xOffset + boxWidth * scaleX} ${y + yOffset + 12 * scaleY}
			L ${x + xOffset + (boxWidth + 5) * scaleX} ${y + yOffset + 10 * scaleY}
			L ${x + xOffset + boxWidth * scaleX} ${y + yOffset + 8 * scaleY}
			L ${x + xOffset + boxWidth * scaleX} ${y + yOffset}
			Z
		  `;

	const textX = x + xOffset + (boxWidth / 2) * scaleX; // adjust this as needed
	const textY = y + yOffset + 10 * scaleY + 5; // adjust this as needed

	return (
		<g>
			<path d={pathD} fill="#ffffff" stroke="#666666" strokeOpacity={0.8} strokeWidth={1.2} />
			<text
				x={textX}
				y={textY}
				fill="#666666"
				fontSize={12}
				textAnchor="middle"
				fontWeight={"500"}
				fontFamily={"Montserrat"}
				fillOpacity={0.8}
			>
				{unitType === "finance" ? "$" : ""}
				{numberToReadableFormat(text)}
			</text>
		</g>
	);
}
